import {ToggleButton} from "react-bootstrap";
import Button from 'react-bootstrap/Button';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import {useListContext} from "../../contexts/ListContext";
import {DataType} from "../../types/enums";


const ListDataType = () => {
  const {listState, setDataType, setDisplayedTableData, setSelectedRowModal} = useListContext();

  const radioDataType: { name: string; value: DataType; }[] = [
    {name: 'Profile Similarity', value: DataType.Correlations},
    {name: 'Negative Interactions', value: DataType.Negative},
    {name: 'Positive Interactions', value: DataType.Positive}
  ];

  const handleDataTypeChange = (dataType: DataType) => {
    return () => { // FIXME: this is a hack to reset the table data when switching data types, should be fixed elsewhere
      setDisplayedTableData(null);
      setSelectedRowModal(null);
      setDataType(dataType);
    }
  }

  return <>
    <ButtonGroup vertical>
      <Button
        className="list-header text-start">
        Data Type
      </Button>
      {radioDataType.map((radio, idx) => (
        <ToggleButton
          key={idx}
          id={`radio-${idx}`}
          className={`btn-${radio.value} bg-transparent border text-dark text-start`}
          type="radio"
          name="radio"
          value={radio.value}
          checked={listState.dataType === radio.value}
          onChange={handleDataTypeChange(radio.value)}
        >
          {radio.name}
        </ToggleButton>
      ))}
    </ButtonGroup>

  </>;
}
export default ListDataType;
